import React from "react";

import { PropsTypeSvg } from "@typings/global.types";

function ChevronRightSVG({ classNameProps, height, width }: PropsTypeSvg) {
  return (
    <svg
      className={classNameProps}
      width={width}
      height={height}
      viewBox='0 0 14 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.93934 0.93934C1.52513 0.353553 2.47487 0.353553 3.06066 0.93934L13.1214 11L3.06066 21.0607C2.47487 21.6465 1.52513 21.6465 0.93934 21.0607C0.353553 20.4749 0.353553 19.5252 0.93934 18.9394L8.87872 11L0.93934 3.06066C0.353553 2.47487 0.353553 1.52513 0.93934 0.93934Z'
        className='dark:fill-icon-dark-primary fill-icon-primary'
      />
    </svg>
  );
}

export default ChevronRightSVG;
